@if (isLargeScreen()) {
	<!-- Inline map on large screens (>= 1000px) -->
	<div class="inline-map-container flex h-full">
		<vb-lxp-map
			class="grow-1"
			[showLabels]="showTurnLabels()"
			[rotation]="0"
			[selectedCarIds]="selectedDrivers()"
		></vb-lxp-map>
		<vb-lxp-panel
			class="z-1 map-drivers-panel h-full"
			#mapDrivers
			[panelKey]="'map-drivers'"
			[panelClass]="'bg-surface-container-low rounded-lg overflow-hidden h-full'"
			[panelHeaderClass]="'p-4 pb-1'"
			[panelBodyClass]="'p-4 pt-1 max-h-150 overflow-y-scroll h-full'"
			[defaultOpenState]="true"
		>
			<div header>Select drivers to follow</div>
			<button
				before-pin-action
				type="button"
				class="map-popout-btn"
				(click)="openFullMapPage()"
				title="Open map in new window"
			>
				<i class="bi bi-box-arrow-up-right"></i>
			</button>
			<div body class="flex flex-col gap-1 h-full">
				<span
					*ngFor="let driver of drivers()"
					[ngClass]="
						selectedDrivers().includes(driver.number)
							? 'bg-secondary-container'
							: 'bg-surface-container hover:bg-surface-container-high'
					"
					class="p-2 rounded"
					(click)="onDriverClick(driver)"
					>#{{ driver.number }} - {{ driver.name }}</span
				>
			</div>
		</vb-lxp-panel>
		<button
			class="absolute bottom-8 right-8 z-0 border-border-default border-1 px-2 py-1 rounded"
			(click)="panelService.togglePanel('map-drivers')"
		>
			Driver Select
		</button>
	</div>
}
